module.exports = __webpack_public_path__ + "static/media/loreal-logo-png-5323615.dfb4521b.png";